import React from 'react'
import { Divider } from 'semantic-ui-react'
// Local
import EncounterAppointment from '../common/encounterAppointment'
import EncounterPatient from '../common/encounterPatient'
import EncounterProfile from '../common/encounterProfile'
import EncounterReason from '../common/encounterReason'
import EncounterReviewer from '../common/encounterReviewer'
import EncounterReviewWarning from '../common/encounterReviewWarning'
import { EncounterDetail } from '../../authenticated/types'
import { shouldRenderReskin2025 } from '../../../constant'
import If from '../../common/if'

/**
 * Provides a component that renders the Physician encounter left nav
 * @param encounterDetail Encounter detail entity
 */

type Props = {
  encounterDetail: EncounterDetail
}

function PhysicianEncounterLeft(
  props: Props
): JSX.Element {
  const { encounterDetail } = props
  const { encounter } = encounterDetail
  return (
    <div>
      <Divider className="green-border" />
      <EncounterReviewWarning
        review={ encounter && encounter.review }
        mode={ undefined }
      />
      <EncounterProfile
        mode="left"
        encounter={ encounter }
      />
      <If isTrue={ shouldRenderReskin2025 }>
        <div className="profile-divider" />
      </If>
      <EncounterPatient
        mode="left"
        encounter={ encounter }
      />
      <EncounterReason
        mode="left"
        encounter={ encounter }
      />
      <EncounterAppointment
        mode="left"
        encounter={ encounter }
      />
      <EncounterReviewer
        mode="left"
        review={ encounter && encounter.review }
      />
    </div>
  )
}

export default PhysicianEncounterLeft
